import { RequestConfig } from '~/common/services/requests';
import { TokenPayload } from '../../../types/apis';
import { VerifyEmailPayload } from '../../../types/requests';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { AUTH_BASE_PATH } from '../constants/authenticationPath';

export const postVerifyEmail = (
  constructPost: ConstructPost,
  data: VerifyEmailPayload,
  headers?: Record<string, string>,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<TokenPayload> | undefined> =>
  constructPost<NonPaginatedResponse<TokenPayload>>(
    `${AUTH_BASE_PATH}/email/verify`,
    { data, headers, params },
    { preventDefaultErrorToast: true },
  );
